// extracted by mini-css-extract-plugin
module.exports = {"embed":"style__embed__9G7WP"};